export default [
  {
    type: "visa",
    flag: "visa",
    bin: /^4/,
    format: /(\d{1,4})/g,
    length: [13, 16],
    cvcLength: [3],
  },
  {
    type: "mastercard",
    flag: "mastercard",
    bin: /^(5[1-5]|2[2-7])/,
    format: /(\d{1,4})/g,
    length: [16],
    cvcLength: [3],
  },
  {
    type: "amex",
    flag: "american-express",
    bin: /^3[47]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: [15],
    cvcLength: [3, 4],
  },
  {
    type: "diners",
    flag: "diners-club",
    bin: /^3[0689]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
    length: [14],
    cvcLength: [3],
  },
  {
    type: "discover",
    flag: "discover",
    bin: /^6([045]|22)/,
    length: [16],
    cvcLength: [3],
  },
  {
    type: "elo",
    flag: "elo",
    format: /(\d{1,4})/g,
    bin: /^4011(78|79)|43(1274|8935)|45(1416|76)|50(4175|6699|67|9[0-9])|63(6297|6368)|6500([3-5])|6504([0-3][0-9])|650(4[8-9]|5)|6507[0-2][0-9]|6509([0-2][0-9])|6516[5-7][0-9]|6550[0-5][0-9]/y,
    length: [16],
    cvcLength: [3],
  }
]
